import loadSelectorsReducer from './loadSelectors.store';
import watchLoadSelectors from './loadSelectors.saga';

export default { loadSelectorsReducer, watchLoadSelectors };
